import { CONFIG } from "../../../config";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import dayjs from 'dayjs';


const CRMCONFIG = CONFIG.modules['crm'];
const API_HOST_CRM = CRMCONFIG.host;


export const useGetCaseAnalytics = (year, month) => {
  const fetchCaseAnalytics = async () => {
    try {
      const response = await axios.get(`${API_HOST_CRM}/analytics/case-analytics`, {
        params: { year, month },
      });

      // Right now assuming the response will be successfull i don't care.

      return response.data;
    } catch (error) {
      console.error("Error fetching case analytics:", error);
      throw error;
    }
  };

  return useQuery({
    queryKey: ["caseAnalytics", year, month],
    queryFn: fetchCaseAnalytics,
    refetchOnWindowFocus: false,
    retry: 2,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
    onError: (error) => {
      console.error("Error in useGetCaseAnalytics:", error);
    },
  });
};

export const useGetCaseAnalyticsRange = (fromDate, toDate, fetchKey) => {
  const fetchCaseAnalytics = async () => {
    try {
      const response = await axios.get(`${API_HOST_CRM}/analytics/case-analytics`, {
        params: { from: fromDate.format('YYYY-MM-DD'), to: toDate.format('YYYY-MM-DD') },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching case analytics:", error);
      throw error;
    }
  };

  return useQuery({
    queryKey: ["caseAnalyticsRange", fromDate.format('YYYY-MM-DD'), toDate.format('YYYY-MM-DD'), fetchKey],
    queryFn: fetchCaseAnalytics,
    refetchOnWindowFocus: false,
    retry: 2,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
    onError: (error) => {
      console.error("Error in useGetCaseAnalyticsRange:", error);
    },
  });
};
